import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

import { COLORS, newLayout } from 'theme';

const AgGridFilterIcon = (props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    style={{
      height: newLayout.spacing.s4,
      width: newLayout.spacing.s4,
      cursor: 'pointer',
    }}
    {...props}
  >
    <path
      fill={props.sx?.color || COLORS.black40}
      d="M3.318 2.682C3.127 2.682 3 2.809 3 3v.955c0 .095.036.155.1.218l5.09 5.41c.064.063.156.099.22.099h3.18c.097 0 .156-.036.22-.1l5.09-5.409c.064-.063.1-.123.1-.218V3c0-.191-.127-.318-.318-.318H3.318Zm4.773 7.636v4.773c0 .127.063.225.159.288l3.182 1.91c.032.032.095.03.159.03.063 0 .096.002.159-.03a.337.337 0 0 0 .16-.289v-6.682H8.09Z"
    />
  </SvgIcon>
);

AgGridFilterIcon.propTypes = {
  sx: PropTypes.object,
};

export default AgGridFilterIcon;
